<template>
  <b-container fluid>
    <b-row class="row-sm" style="height: 100vh">
      <b-col class="login-right">
        <b-row class="reset">
          <b-col offset="2" cols="8">
            <div>
              <h4 style="font-weight: 700" class="pb-2 text-center">
                Enter New Password
              </h4>
              <p
                style="color: var(--gray-400); font-size: 1.125rem"
                class="pb-3 text-center"
              >
                Almost done! Enter your new password to complete this process
              </p>
              <div class="invalid-feedback d-block">
                {{ error }}
                <span class="text-success">{{ success }}</span>
              </div>
              <b-form @submit.prevent="submit">
                <div class="pb-3">
                  <label>Password</label>
                  <b-form-input
                    :class="{ 'is-invalid': $v.password.$error }"
                    :type="inputType"
                    placeholder="Enter Password"
                    v-model.trim="$v.password.$model"
                    trim
                  />
                  <img
                    class="eye"
                    :class="{
                      'eye-mt': inputType == 'text',
                    }"
                    :src="require('./../assets/icons/eye-' + eyeState + '.svg')"
                    alt="Hidden"
                    @click="toggleEyeState"
                  />
                  <div class="validations">
                    <span :class="{ 'text-success': $v.password.required }">
                      <img
                        v-if="$v.password.required"
                        src="./../assets/icons/check.svg"
                        alt="Passed"
                      />
                      {{ errorMessages.required }}
                    </span>
                    <span
                      :class="{
                        'text-success': $v.password.$model.length >= 8,
                      }"
                    >
                      <img
                        v-if="$v.password.$model.length >= 8"
                        src="./../assets/icons/check.svg"
                        alt="Passed"
                      />
                      {{ errorMessages.minLength }}
                    </span>
                    <span
                      :class="{ 'text-success': $v.password.upperCaseCheck }"
                    >
                      <img
                        v-if="$v.password.upperCaseCheck"
                        src="./../assets/icons/check.svg"
                        alt="Passed"
                      />
                      {{ errorMessages.upperCaseCheck }}
                    </span>
                    <span :class="{ 'text-success': $v.password.numberCheck }">
                      <img
                        v-if="$v.password.numberCheck"
                        src="./../assets/icons/check.svg"
                        alt="Passed"
                      />
                      {{ errorMessages.numberCheck }}
                    </span>
                    <span
                      :class="{ 'text-success': $v.password.specialCharCheck }"
                    >
                      <img
                        v-if="$v.password.specialCharCheck"
                        src="./../assets/icons/check.svg"
                        alt="Passed"
                      />
                      {{ errorMessages.specialCharCheck }}
                    </span>
                  </div>
                </div>
                <b-button
                  :disabled="user.loading || $v.password.$invalid"
                  type="submit"
                  block
                  variant="primary"
                  v-if="!status"
                  >{{
                    user.loading ? "Loading..." : "Reset Password"
                  }}</b-button
                >
                <router-link to="/login" v-else>
                  <b-button block variant="primary"> Login </b-button>
                </router-link>
              </b-form>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";

export default {
  name: "ResetPassword",
  data() {
    return {
      password: "",
      email: "",
      token: "",
      disabled: true,
    };
  },
  validations: {
    password: {
      required,
      minLength: minLength(8),
      upperCaseCheck(password) {
        return /[A-Z]/.test(password) && /[a-z]/.test(password); // checks for a-z
      },
      numberCheck(password) {
        return /[0-9]/.test(password); // checks for 0-9
      },
      specialCharCheck(password) {
        return /\W|_^\S*$/.test(password); // checks for special char
      },
    },
  },
  methods: {
    ...mapActions({
      resetPassword: "user/resetPassword",
    }),
    toggleEyeState() {
      this.$store.dispatch("toggleEyeState");
    },
    submit() {
      this.$store.state.eye.inputType = "password";
      this.$store.state.eye.eyeState = "hidden";
      this.$store.state.user.error = null;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.resetPassword({
          email: this.email,
          token: this.token,
          new_password: this.password,
        });
      }
    },
  },
  computed: mapState({
    user: (state) => state.user,
    error: (state) => state.user.error,
    success: (state) => state.user.success,
    status: (state) => state.user.status,
    errorMessages: (state) => state.user.errorMessages,
    inputType: (state) => state.eye.inputType,
    eyeState: (state) => state.eye.eyeState,
  }),
  destroyed() {
    this.$store.state.user.error = null;
    this.$store.state.user.success = null;
    this.$store.state.user.status = null;
  },
  created() {
    let queryParams = window.location.search;
    const params = queryParams.slice(7).split("&");
    this.email = params[0].replace("%40", "@");
    this.token = params[1].slice(6);
  },
};
</script>

<style></style>
